import React from 'react';
import Box from '@mui/material/Box';

import { styled } from '@mui/material/styles';
import { HeaderCellProps } from '../../models/configurableTable';
import { SortableHeaderIdicator } from './SortableHeaderIdicator';
import { HeaderField } from './HeaderField';

export const TableCellContent = styled(Box)(({ theme }) => ({
  height: 'var(--DataGrid-headerHeight)',
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: '100%',
  '& .dragBox': {
    paddingRight: theme.spacing(18),
    opacity: 0,
    '& svg': {
      display: 'block',
      margin: 'auto',
    },
  },
  '&:hover .dragBox': {
    opacity: 1,
  },
}));

export const TableCellDataBox = styled(Box)<{
  sortable: boolean;
  align: 'left' | 'right' | 'center';
}>(({ sortable, align, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: align,
  marginLeft: sortable || align !== 'left' ? 0 : theme.spacing(16),

  width: '100%',
  '& .MuiIconButton-root': {
    padding: '0',
  },
  '& .sort': {
    opacity: 0,
  },
  '&:hover .sort': {
    opacity: 1,
  },
  '& span': {
    overflow: 'hidden',
    '& div': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
}));

export const HeaderCell: React.FC<HeaderCellProps> = ({ primaryText, secondaryText, colDef }) => {
  const primaryFieldSortable = !!colDef.sortable;
  const secondartFieldSortable = !!colDef.subField?.sortable;

  return (
    <TableCellContent>
      <TableCellDataBox
        data-testid="tableHeaderPrimary"
        sortable={primaryFieldSortable}
        align={colDef.headerAlign ?? 'left'}
      >
        {primaryFieldSortable && (
          <SortableHeaderIdicator field={colDef.field} data-testid="primarySortingIndicator" />
        )}
        <HeaderField>{primaryText}</HeaderField>
      </TableCellDataBox>
      <TableCellDataBox
        data-testid="tableHeaderSecondary"
        sortable={secondartFieldSortable}
        align={colDef.headerAlign ?? 'left'}
      >
        {secondartFieldSortable && (
          <SortableHeaderIdicator
            field={colDef.subField!.field}
            data-testid="secondarySortingIndicator"
          />
        )}
        <HeaderField variant="secondary">{secondaryText}</HeaderField>
      </TableCellDataBox>
    </TableCellContent>
  );
};
